import React from "react";
import { FaInfoCircle } from "react-icons/fa";

import Reveal from "../../../components/ui/Reveal";
import SectionTitle from "../HomePage/SectionTitle";
import { resolveMediaUrl } from "../HomePage/homeUtils";

const About = ({ section }) => {
  if (!section) return null;

  const hasContent = Boolean(section.about_content);

  return (
    <section
      id="about"
      className="bg-white py-16 text-slate-900 dark:bg-slate-900 dark:text-white sm:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTitle
          eyebrow="Présentation"
          title="À propos de "
          highlight="l’association"
          subtitle={`Découvrez la présentation de ${section.nom_section}.`}
        />

        <Reveal>
          <div className="grid gap-8 rounded-[2rem] border border-slate-200 bg-slate-50 p-6 shadow-sm dark:border-white/10 dark:bg-slate-950 lg:grid-cols-[320px_1fr] lg:p-8">
            <div className="flex items-center justify-center">
              <div className="relative">
                <div className="absolute inset-0 rounded-[2rem] bg-primary/10 blur-2xl" />

                <div className="relative flex h-56 w-56 items-center justify-center overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-6 shadow-xl dark:border-white/10">
                  {section.logo_section ? (
                    <img
                      src={resolveMediaUrl(section.logo_section)}
                      alt={`Logo ${section.nom_section}`}
                      className="h-full w-full object-contain"
                    />
                  ) : (
                    <FaInfoCircle className="text-5xl text-primary" />
                  )}
                </div>
              </div>
            </div>

            <div className="flex flex-col justify-center">
              <h3 className="text-2xl font-bold text-slate-950 dark:text-white">
                {section.nom_section}
              </h3>

              {section.discipline_section && (
                <p className="mt-2 text-sm font-bold uppercase tracking-wide text-primary">
                  {section.discipline_section}
                </p>
              )}

              {hasContent ? (
                <div
                  className="prose prose-slate mt-6 max-w-none leading-8 dark:prose-invert prose-p:text-slate-600 dark:prose-p:text-slate-300"
                  dangerouslySetInnerHTML={{ __html: section.about_content }}
                />
              ) : (
                <p className="mt-6 leading-8 text-slate-600 dark:text-slate-300">
                  La présentation de cette association sera prochainement disponible.
                </p>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;